import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { BackgroundImageContainerComponent } from '../background-image-container/background-image-container.component';
import { CommonModule } from '@angular/common';
import { MatError } from '@angular/material/form-field';

@Component({
  selector: 'app-logo-card-container',
  host: { class: 'logo-card-container' },
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    BackgroundImageContainerComponent,
    MatError,
  ],
  templateUrl: './logo-card-container.component.html',
  styleUrl: './logo-card-container.component.scss',
})
export class LogoCardContainerComponent {
  @Input() cardWidth: string = '600px';
  @Input() backgroundImage: string = '';
  @Input() tintMode: 'none' | 'full' | 'strip' = 'none';
  @Input() title: string | null = null;
  @Input() subTitle: string | null = null;
  @Input() isLoading: boolean = false;
  @Input() hasError: boolean = false;
  @Input() errorMessage: string | null = null;
  @Output() retry = new EventEmitter<void>();

  handleRetryClick(event: MouseEvent): void {
    event.preventDefault();
    this.retry.emit();
  }
}
